'use strict';

var Marionette = require('backbone.marionette');

export default Marionette.View.extend({

  tagName: 'option',
  template: require('./templates/select-item.hbs'),

  initialize: function (options) {
    this.collection = options.collection || [];
    this.selectedStaff = options.selectedStaff;
  },

  onRender: function () {
    this.$el.attr('value', this.model.get('id'));

    if (this.model.get('supported_locale') && this.hasSupportedLanguages()) {
      this.$el.attr('supportedLocales', this.model.get('supported_locale'));
    }

    if (this.selectedStaff && this.selectedStaff.id === this.model.id) {
      this.$el.attr('selected', 'selected');
    }
  },

  serializeData: function () {
    const { attributes } = this.model;

    return {
      fullName: attributes.full_name || `${attributes.first_name} ${attributes.last_name}`,
    };
  },

  hasSupportedLanguages: function () {
    const languages = window.ALL_STAFF_LANGUAGES.filter(language => (
      this.collection.some(user => (
        user.get('supported_locale').split(',').includes(language.abbr)
      ))
    ));

    return languages.length > 1;
  },
});
